import React from "react";
import {connect} from "react-redux";
import moment from "moment";
import locale from "../../locale";
import {setRegistered} from "../../actions/registered";
import {clientGet} from "../../api";

function RegistrationPreview(props)
{
	const {event, onRegistrationButtonClick, settings} = props;

	const showTitle = !settings || !settings.hasOwnProperty('showTitle') || settings.showTitle;
	const showDateStart = !settings || !settings.hasOwnProperty('showDateStart') || settings.showDateStart;

	return (
		<section className="player-text-layer player-registration-enter">
			<table>
				<tbody>
				<tr>
					<td>
						<h1>{showTitle ? locale.getProperty(event, 'name') : null}</h1>
					</td>
				</tr>
				<tr>
					<td>
						{showDateStart ?
						<p>
							{locale.getProperty(settings, 'dateTitle') || locale.get('player-registration-online-conference')}
							<br />
							{moment.unix(event.timeStart).format('LLL')} (UTC{moment.unix(event.timeStart).format('Z')})
						</p>: null}
						<p>
							<button onClick={onRegistrationButtonClick}>
								{locale.getProperty(settings.registerButton, 'title') || locale.get('player-registration-button-title')}
							</button>
						</p>
					</td>
				</tr>
				</tbody>
			</table>
		</section>
	);
}

function PlayerFrameContainer(props)
{
	const {watchKey} = props;

	setTimeout(() => {
		if (!window.hasOwnProperty('comdiLoader')) {
			console.error('comdiLoader is not found in window context');

			return;
		}

		const frame = window.broadcastLoader.createPlayer(document.getElementById('player-embed'));
		window.addEventListener('message', e => {
			if (e.source !== frame.contentWindow) {
				return;
			}

			try {
				const message = JSON.parse(e.data);

				if (message.setHeight) {
					window.scroll(0, frame.offsetTop);
				}
			} catch (e) {
				console.warn(e);
			}
		});
	}, 100);

	return (
		<section className="player-text-layer player-embed-container">
			<div id="player-embed"
				 data-eventKey={watchKey}
				 data-no-reg={location.hash.indexOf('no-reg') >= 0 ? 'true' : ''}
				 lang={locale.currentLocaleName}
			/>
		</section>
	);
}

class LayoutPlayer extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.state = {
			view: 'main',
		};

		window.addEventListener('message', (event) => {
			try {
				const message = typeof event.data === 'object' ? event.data : JSON.parse(event.data);

				if (message.isRegistered) {
					this.props.setRegistered(true);

					if (window.hasOwnProperty('fbq')) {
						window.fbq('track', 'CompleteRegistration');
					}

					if (window.hasOwnProperty('ym') && props.event.eventKey === 'ewv1271x') {
						window.ym(64920970, 'reachGoal', 'registration');
					}
				}
			} catch (e) {
			}
		}, false);
	}

	componentDidMount() {
		const {event} = this.props;

		(async () => {
			const isRegistrationRequired = event.moduleAuth.require;

			if (isRegistrationRequired) {
				const isRegistered = await this.requestRegistration();
				if (!isRegistered) {
					return;
				}
			}

			this.props.setRegistered(true);
			this.showPlayer();
		})();
	}

	async requestRegistration()
	{
		const {event} = this.props;

		return clientGet(event.eventKey)
			.then(response => response && response.id)
		;

		// return comdi.registrationCheck(event.eventKey)
		// 	.then((response) => true)
		// ;
	}

	showPlayer()
	{
		this.setState({view: 'player'});
	}

	render()
	{
		const {event, watchKey, settings} = this.props;

		let View = RegistrationPreview;
		if (this.state.view === 'player') {
			View = PlayerFrameContainer;
		}

		const backgroundImage = event.stream[0].preview || event.modulePage.backgroundUrl || null;

		let mainStyle = Object.assign({}, settings.style);
		if (backgroundImage && !mainStyle.backgroundImage && (!settings || !settings.hasOwnProperty('showPoster') || settings.showPoster)) {
			mainStyle.backgroundImage = `url(${backgroundImage})`;
		}

		let fadeStyle = Object.assign({}, settings.styleFade);
		if (View === PlayerFrameContainer) {
			if (!settings.hasOwnProperty('showFade') || settings.showFade) {
				fadeStyle.backgroundColor = '#' + event.moduleTheme.backgroundColor;
			}

			Object.assign(mainStyle, settings.styleRegistered);
			Object.assign(fadeStyle, settings.styleFadeRegistered);
		}

		return (
			<main id="player" style={mainStyle}>
				<div className="player-poster-fade" style={fadeStyle}>
					<View
						event={event}
						watchKey={watchKey}
						onRegistrationButtonClick={this.showPlayer.bind(this)}
						settings={settings}
					/>
				</div>
			</main>
		);
	}
}

const mapStateToProps = (store) => ({
	watchKey: store.watchKey,
	event: store.event,
	registered: store.registered,
});

const mapDispatchToProps = (dispatch) => ({
	setRegistered: (registered) => dispatch(setRegistered(registered)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutPlayer);
